export const SET_INFO_MODAL_TRADE_ITEM = 'SET_INFO_MODAL_TRADE_ITEM'
export const SET_IS_OPEN_MODAL_INFO = 'SET_IS_OPEN_MODAL_INFO'
